import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FiltersComponent } from './filters/filters.component';
import { ChartComponent } from './charts/chart.component';
import { OverviewComponent } from './tabs/overview.component';
import { AttritionComponent } from './tabs/attrition.component';
import { ClaimsComponent } from './tabs/claims.component';
import { ProjectExpensesComponent } from './tabs/project-expenses.component';
import { LeaveMapComponent } from './tabs/leave-map.component';
import { RiskComponent } from './tabs/risk.component';
import { ExportComponent } from './tabs/export.component';
import { InfoTooltipComponent } from './info-tooltip.component';
import { LeaveSummaryTableComponent } from './leave-summary-table.component';

@NgModule({
  declarations: [
    DashboardComponent,
    FiltersComponent,
    ChartComponent,
    OverviewComponent,
    AttritionComponent,
    ClaimsComponent,
    ProjectExpensesComponent,
    LeaveMapComponent,
    RiskComponent,
    ExportComponent,
    InfoTooltipComponent,
    LeaveSummaryTableComponent,
  ],
  imports: [CommonModule, FormsModule, RouterModule],
  exports: [DashboardComponent],
})
export class WorkforceModule {}
